import { render, staticRenderFns } from "./ReciboCreate.vue?vue&type=template&id=21bd8eb1&scoped=true&lang=es"
import script from "./ReciboCreate.vue?vue&type=script&lang=js"
export * from "./ReciboCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd8eb1",
  null
  
)

export default component.exports